// src/components/ui/FancySelect.js
import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/24/outline';

export default function FancySelect({
    value,
    onChange,
    options,
    placeholder = 'Select...',
    className = '',
}) {
    const selected = options.find(o => o.value === value) || null;

    return (
        <Listbox value={value} onChange={onChange}>
            <div className={`relative ${className}`}>
                {/* Button - styled to match form inputs exactly */}
                <Listbox.Button
                    style={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '1rem',
                        lineHeight: '1.5rem',
                        width: '100%',
                        borderRadius: '0.5rem',
                        border: '2px solid #d1d5db',
                        padding: '0.75rem 1rem',
                        backgroundColor: '#ffffff',
                        outline: 'none',
                        transition: 'border-color 200ms ease',
                        boxShadow: 'none',
                        textAlign: 'left',
                        position: 'relative',
                    }}
                    className="hover:!border-[var(--jade-green)] focus:!border-[var(--jade-green)]"
                >
                    <span
                        className={`block truncate ${selected ? 'text-[var(--charcoal-black)]' : 'text-gray-400'
                            }`}
                    >
                        {selected ? selected.label : placeholder}
                    </span>
                    <ChevronUpDownIcon
                        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[var(--forest-green)]"
                    />
                </Listbox.Button>

                {/* Options dropdown */}
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                    enter="transition ease-out duration-100"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                >
                    <Listbox.Options
                        className="
              absolute z-20 mt-2 max-h-60 w-full overflow-auto
              rounded-xl bg-white shadow-xl ring-1 ring-black/5
              outline-none
            "
                    >
                        {options.map(opt => (
                            <Listbox.Option
                                key={opt.value}
                                value={opt.value}
                                className={({ active }) =>
                                    `
                    relative cursor-pointer select-none px-4 py-3
                    ${active
                                        ? 'bg-[var(--pale-mint)] text-[var(--charcoal-black)]'
                                        : 'text-[var(--charcoal-black)]'
                                    }
                  `
                                }
                            >
                                {({ selected }) => (
                                    <>
                                        <span
                                            className={`block truncate ${selected ? 'font-semibold' : 'font-normal'
                                                }`}
                                        >
                                            {opt.label}
                                        </span>
                                        {selected && (
                                            <CheckIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[var(--forest-green)]" />
                                        )}
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    );
}